import { z } from 'zod';

/**
 * Zweck-Enum für Event-Mail-Template-Verknüpfungen.
 * Definiert wofür ein Mail-Template bei einem Event verwendet wird.
 */
export const EventMailTemplatePurposeSchema = z.enum([
  'registration_confirmation',
  'registration_draft',
  'ticket_assigned',
  'ticket_confirmed',
  'waitlist_notification',
  'cancellation',
  'reminder',
  'rejection',
  'approval',
  'user_blocked',
  'post_event_feedback',
  'custom',
]);

/** TypeScript Type für Event-Mail-Template-Zweck */
export type EventMailTemplatePurpose = z.infer<typeof EventMailTemplatePurposeSchema>;

/**
 * Zod Schema für EventMailTemplate — Runtime-Validierung + Type-Inference.
 * Verknüpft ein MailTemplate mit einem Event für einen spezifischen Zweck.
 */
export const EventMailTemplateSchema = z.object({
  id: z.string().cuid(),
  eventId: z.string().cuid(),
  mailTemplateId: z.string().cuid(),
  purpose: EventMailTemplatePurposeSchema,
  createdAt: z.coerce.date(),
});

/** TypeScript Type — abgeleitet aus dem Zod Schema */
export type EventMailTemplate = z.infer<typeof EventMailTemplateSchema>;

/**
 * Schema für EventMailTemplate-Erstellung.
 */
export const CreateEventMailTemplateSchema = EventMailTemplateSchema.pick({
  eventId: true,
  mailTemplateId: true,
  purpose: true,
});

/** TypeScript Type für EventMailTemplate-Erstellung */
export type CreateEventMailTemplate = z.infer<typeof CreateEventMailTemplateSchema>;
